import { useEffect, useRef, useState } from "react";

const EASE = "cubic-bezier(0.22, 1, 0.36, 1)";

function useInView(threshold = 0.12) {
  const ref = useRef(null);
  const [go, setGo] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setGo(true);
            io.unobserve(e.target);
          }
        });
      },
      { threshold, rootMargin: "0px 0px -6% 0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [threshold]);
  return [ref, go];
}

// Subtle, smooth, flicker-free reveal. Optional gentle zoom.
export const Reveal = ({ children, className = "", delay = 0, y = 22, zoom = false, as: Tag = "div", ...rest }) => {
  const [ref, go] = useInView();
  const style = {
    opacity: go ? 1 : 0,
    transform: go ? "none" : `translateY(${y}px)${zoom ? " scale(0.96)" : ""}`,
    transition: `opacity 0.9s ${EASE} ${delay}s, transform 1s ${EASE} ${delay}s`,
    willChange: "opacity, transform",
  };
  return (
    <Tag ref={ref} className={className} style={style} {...rest}>
      {children}
    </Tag>
  );
};

// Headline reveal — one smooth fade/rise for the whole heading (no per-line flicker).
export const MaskReveal = ({ lines = [], className = "", delay = 0 }) => {
  const [ref, go] = useInView(0.1);
  return (
    <span
      ref={ref}
      className={`block ${className}`}
      style={{
        opacity: go ? 1 : 0,
        transform: go ? "none" : "translateY(26px)",
        transition: `opacity 1s ${EASE} ${delay}s, transform 1.1s ${EASE} ${delay}s`,
        willChange: "opacity, transform",
      }}
    >
      {lines.map((l, i) => (
        <span key={i} className="block">{l}</span>
      ))}
    </span>
  );
};
